import * as types from "./dashboard.action.types";

export default {
  [types.GET_SCREENING_DATES]: (state, res) => {
    state.screeningDates = res;
  },
};
